<template>
    <a-drawer :title="title" width="400" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="分组名称" prop="name">
                <a-input v-model="field.name" placeholder="请填写用户分组名称" />
            </a-form-model-item>
            <a-form-model-item label="分组描述" prop="memo">
                <a-textarea v-model="field.memo" placeholder="请填写用户分组描述" :rows="3" />
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            field: {
                id: '',
                name: '',
                memo: ''
            },
            rules: {
                name: [{ required: true, message: '请填写分组名称', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        if (this.item.id) {
            Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
        }
    },
    methods: {
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/cts/ate/tester/org/save', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
            }
        }
    }
}
</script>
